import { FC } from "react";

export const ArcadeEmbed: FC = () => {
  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "calc(57.666666666666664% + 41px)",
        height: 0,
        width: "100%",
      }}
    >
      <iframe
        src="https://demo.arcade.software/OxRmLHkyT45Wx1SPnU9W?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
        title="Sky AI — Chaos to Clarity v2"
        frameBorder="0"
        loading="lazy"
        allowFullScreen
        allow="clipboard-write"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          colorScheme: "light",
        }}
      />
    </div>
  );
};
